import React from 'react'
import Link from 'next/link'
import { motion } from 'framer-motion'
import { ArrowRightIcon } from '@heroicons/react/solid'

import { FeaturedImg, Author } from '../../models/blog'

interface BlogProps {
  totalComments: string
  slug: string
  title: any
  category: any
  featuredImg: FeaturedImg
  excerpt: string
  author: Author
  publishDate: any
  diff?: {
    m: number
    y: number
  }
}

export default function SingleBlog(props: BlogProps) {
  const {
    totalComments,
    slug,
    title,
    category,
    featuredImg,
    excerpt,
    author,
    publishDate,
    diff
  } = props

  const renderDate = () => {
    if (diff !== undefined) {
      if (diff.y === 0) {
        return `${diff.m + 1} months ago`
      } else {
        return `${diff.y} year ago`
      }
    }
  }

  return (
    <div className="blog-post">
      <div className="flex justify-center items-start img-container">
        <Link href={`/blog/${slug}`}>
          <img
            loading="lazy"
            className="cursor-pointer rounded-md blog-img single-blog-img"
            src={featuredImg.large}
          />
        </Link>
      </div>

      <div className="flex flex-wrap mt-6 mb-5">
        {category.length > 0 &&
          category.map((singleCat: any) => (
            <Link
              key={singleCat.slug}
              href={`/blog/category/${singleCat.slug}`}
            >
              <a className="mx-2 text-xs font-bold tracking-widest uppercase text-brand">
                <span
                  dangerouslySetInnerHTML={{ __html: singleCat.cat_name }}
                />
              </a>
            </Link>
          ))}
      </div>

      <Link href={`/blog/${slug}`}>
        <a className="block mb-3 font-bold">
          <h4
            className="max-w-sm text-2xl font-black tracking-tight lg:text-2xl hover:text-gray-800"
            dangerouslySetInnerHTML={{ __html: title.rendered }}
          />
        </a>
      </Link>

      <div className="mb-3 text-sm text-gray-600 grid grid-cols-3">
        {author && <span>{author.name}</span>}
        {publishDate && <span className="text-center">{renderDate()}</span>}
        {parseInt(totalComments) > 0 && (
          <span className="text-right">{totalComments} comments</span>
        )}
      </div>

      <div
        className="mb-3 text-justify excerpt"
        dangerouslySetInnerHTML={{ __html: excerpt }}
      />

      <Link href={`/blog/${slug}`}>
        <motion.a
          className="flex items-center justify-end font-bold leading-none text-right gap-2 text-brand"
          whileHover={{
            x: 3
          }}
          whileTap={{
            x: 7
          }}
        >
          Read More
          <ArrowRightIcon width={18} height={18} />
        </motion.a>
      </Link>
    </div>
  )
}
